import { Form, Field } from 'formik';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import * as Yup from 'yup';

const form =
  ({ role, allCompany, isEditing, loading }) =>
  ({ errors, touched, setFieldValue }) =>
    (
      <Form>
        <div className='m-0 form'>
          {role === 'admin' && !isEditing && (
            <div className='form__elem'>
              <span className='p-float-label'>
                <Field name='company' className={errors.company && touched.company ? 'p-invalid' : ''}>
                  {({ field }) => (
                    <Dropdown
                      value={field.value}
                      options={allCompany ?? []}
                      onChange={(e) => setFieldValue('company', e.value)}
                      optionLabel='name'
                    />
                  )}
                </Field>
                <label htmlFor='company'>Підриємство</label>
              </span>
              {errors.company && touched.company ? (
                <small id='company-help' className='p-error'>
                  {errors.company}
                </small>
              ) : null}
            </div>
          )}
          <div className='form__elem'>
            <span className='p-float-label'>
              <Field name='name' as={InputText} className={errors.name && touched.name ? 'p-invalid' : ''} />
              <label htmlFor='name'>Назва</label>
            </span>
            {errors.name && touched.name ? (
              <small id='name-help' className='p-error'>
                {errors.name}
              </small>
            ) : null}
          </div>
          <Button
            type='submit'
            loading={loading}
            className='form__button'
            label={isEditing ? 'Зберегти' : 'Створити'}
            icon='pi pi-check'
          />
        </div>
      </Form>
    );
const schema = ({ role, isEditing }) => {
  return Yup.object().shape({
    ...(role === 'admin' && !isEditing
      ? {
          company: Yup.object().required('Виберіть підприємство'),
        }
      : {}),
    name: Yup.string().min(1, 'Занадто коротке!').max(100, 'Занадто довге!'),
  });
};

const initialValues = (data, role, isEditing) => {
  return {
    ...(role === 'admin' && !isEditing
      ? {
          company: data?.company_id ? { _id: data?.company_id, name: data?.company_name } : null,
        }
      : {}),
    name: data?.name ?? '',
  };
};

export default { form, schema, initialValues };
